import { render, staticRenderFns } from "./TaskSampleTab.vue?vue&type=template&id=46fc8b2e&scoped=true&"
import script from "./TaskSampleTab.vue?vue&type=script&lang=js&"
export * from "./TaskSampleTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fc8b2e",
  null
  
)

export default component.exports